import { ParentBusiness, Sysappbuttons, Sysdic } from 'fccore2';
import { Fcapp } from 'fccore2';
import { FctlblistitemComponent } from '../fctlb/fctlblistitem.component';
import { CommonService } from 'fccore2';
import { FormGroup } from '@angular/forms';
import { Sysapplinks } from 'fccore2';
export const fclistOption: GRIDOPTIONS = {
  /** ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼ */
  fcClass: 'ag-theme-blue',
  fcHeight: 450,
  fcPaginationPageSize: 20,
  fcRowHeight: 28,
  /** æ¯å¦å¯ç¨æ¥è¯¢ */
  fcEnableSearch: false,
  /** æ¯å¦å¯ç¨æåº */
  fcEnableSorting: true,
  /** æ¯å¦å¯ç¨è¿æ»¤ */
  fcEnableFilter: true,
  /** æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å° */
  fcEnableColResize: true,
  /** æ¯å¦æ¾ç¤ºå·¥å·æ  */
  fcShowToolPanel: true,
  /** æ¯å¦åé¡µ */
  fcPagination: true,
  /** æ¯å¦æ¾ç¤ºåç»  alwaysæ»æ¯æ¾ç¤ºï¼noneä¸æ¾ç¤º */
  fcRowGroupPanelShow: 'none',
  /** æ¯å¦å¯ç¨ç¶ææ  */
  fcEnableStatusBar: true,
  /** æ¯å¦å¯ç¨åºåéä¸­ */
  fcEnableRangeSelection: true,
  /** éä¸­æ¹å¼ */
  fcRowSelection: 'multiple',
  /** æ¯å¦å¯ç¨æä½å */
  fcEnableAction: true,
  // æä½æé®ä½ç½®
  fcActionPosition: 'right',
  /** éä¸­æcheckbox */
  fcCheckboxSelection: true,
  /** æ¯å¦å¯ç¨ç¼è¾ */
  fcEnableEdit: true,
  /** æ¯å¦å¯ç¨è¡å· */
  fcEnableRownum: true,
  /** æ¯å¦èªå¨ä¿å­ */
  fcAutoSave: true,
  /** èªå¨è°æ´å¤§å° */
  fcAutoSize: true,
  /** æ¯å¦å¯ç¨ä¸æ */
  fcSelect: false,
  /** æ¯å¦å¯ç¨æ°æ®å­å¸çcheckbox */
  fcEnableDic: false,
  /** é»è®¤çæ¸²æ */
  fcFieldsRender: {},
  // æé®
  fcButtons: [],
  // åç»
  fcFieldsGroup: [],
  // å­å¸åè¡¨
  fcDics: []
};
/**
 * æ ¹æ®åæ°è·ååè¡¨çæ é¢
 * @param appId æ¨¡åç¼ç 
 * @param fcOption éç½®ä¿¡æ¯
 */
export  function getFieldsConfByAppid(this1: any, fcBustype: string, appId: string, fcOption): Fclistdatafield[] {
  if (fcOption === undefined || fcOption === null) {
    fcOption = fclistOption;
  }
  let fcApp: Fcapp;
  if (appId) {
    fcApp = ParentBusiness.appService.getAppById(appId);
  } else {
    fcApp  = {
      SYSAPPFIELDS: fcOption.fcFields || [],
      SYSAPPFLDGROUP: fcOption.fcFieldsgroup || [],
      SYSAPPLINKS: fcOption.fcApplinks || [],
      SYSDIC: fcOption.fcDic || [],
      SYSAPPBUTTONS: fcOption.fcButtons || []
    };
  }
  return getFieldsConfByApp(this1, fcBustype, fcApp, fcOption);
}
/**
 * è¿åå¸¦checkbox
 * @param fcOption xuanx
 */
export function getCheckbox(fcOption): any {
return {
  field: '',
  suppressSizeToFit: true,
  suppressResize: true,
  suppressMovable: false,
  suppressFilter: true,
  headerCheckboxSelection: fcOption.fcCheckboxSelection,
  checkboxSelection: fcOption.fcCheckboxSelection,
  suppressSorting: true,
  menuTabs: [],
  sortingOrder: [],
  width: 35
};
}
/**
 * è¿åæä½å
 */
export function getRownum(): any {
  return {
    headerName: 'åºå·',
    field: 'ROWNUM',
    suppressSizeToFit: true,
    suppressResize: true,
    cellClass: 'text-center',
    suppressMovable: false,
    suppressFilter: true,
    suppressSorting: true,
    menuTabs: [],
    sortingOrder: [],
    width: 50
  };
}
/**
 * æ ¹æ®é¿åº¦è·åæé®
 * @param width é¿åº¦
 */
export function getAction(fcApp: Fcapp, fcBustype?: string): any {
  let width = 110;
  if (fcApp) {
    width = 0;
    if (fcBustype) {
      fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LISTONE' && btn.BUSTYPE === fcBustype).forEach(
        btn => {
          width += btn.BTNNAME.length * 17 + 10;
        }
      );
    } else {
      fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LISTONE').forEach(
        btn => {
          width += btn.BTNNAME.length * 17 + 10;
        }
      );
    }
  }
  return {
    headerName: 'æä½',
    field: 'DOACTION',
    enableRowGroup: false,
    enablePivot: false,
    allowedAggFuncs: [],
    suppressMovable: true,
    suppressSizeToFit: true,
    suppressFilter: true,
    menuTabs: [],
    sortingOrder: [],
    cellRendererFramework: FctlblistitemComponent,
    width
  };
}
/**
 * éä¸­ï¼fcSelectedFieldNameä½ä¸ºkeyï¼æ»¡è¶³valuesä¸­çå¼ä¸ºåçåéä¸­
 * @param ids idéå
 */
export function selectRowById(gridApi, values: string[], fcSelectedFieldName: string) {
  gridApi.forEachNode(node => {
    if (
      values.filter(value => node.data[fcSelectedFieldName] === value)
        .length > 0
    ) {
      node.selected = true;
    } else {
      node.selected = false;
    }
    gridApi.updateRowData({ update: [node.data] });
  });
}
/**
 * æ ¹æ®æ¨¡ååéç½®è·ååä¿¡æ¯
 * @param fcApp æ¨¡ååç§°
 * @param fcOption éé¡¹
 */
export function getFieldsConfByApp(this1: any, fcBustype: string, fcApp: Fcapp, fcOption = this.fcOption): Fclistdatafield[] {
 if (fcApp) {
   const fieldsList = fcApp.SYSAPPFIELDS.filter(field => {
     if (fcOption.fcShowFields === undefined || (fcOption.fcShowFields && fcOption.fcShowFields.indexOf(field.FIELDCODE) !== -1)) {
       return true;
     } else {
       return false;
     }
   });
   const fields: Fclistdatafield[] = [];
   // éæ©å¤éæ¡
   if (
     fcOption.fcCheckboxSelection !== undefined &&
     fcOption.fcCheckboxSelection
   ) {
     if (
       fcOption.fcTreeData === undefined ||
       fcOption.fcTreeData === false
     ) {
       fields.push(getCheckbox(fcOption));
     }
   }
   if (fcOption.fcTreeData === undefined || fcOption.fcTreeData === false) {
     if (
       fcOption.fcEnableRownum === undefined ||
       fcOption.fcEnableRownum === true
     ) {
       // åºå·
       fields.push(getRownum());
     }
   }
   // æä½æé®å¨å·¦è¾¹
   if (fcOption.fcEnableAction && fcOption.fcActionPosition === 'left') {
     fields.push(getAction(fcApp, fcBustype));
   }
   // æ ¡éªæ¯å¦å·²ç»å¤çè¿çfield
   const checkFieldIsProcessEd = fcOption.fcFields === undefined ? true : (fcOption.fcFields.filter(f => f.field !== undefined).length === 0);
   if (!checkFieldIsProcessEd) {
     return fcOption.fcFields;
   }
   let locktimes = 0;
   fieldsList.forEach(element => {
     // èªå®ä¹ç»ä»¶æ¾ç¤º
     if (((fcOption.fcShowFields && fcOption.fcShowFields.indexOf(element.FIELDCODE) !== -1) || checkFieldIsProcessEd)  && fcOption.fcFieldsRender &&  fcOption.fcFieldsRender[element.FIELDCODE]) {
        const width = element.LISTMAXLEN ? element.LISTMAXLEN * 13 + 10 : 5 * 13 + 10;
        const field: Fclistdatafield = {
             headerName: element.FIELDNAME,
             field: element.FIELDCODE,
             enableRowGroup: false,
             enablePivot: false,
             allowedAggFuncs: [],
             suppressMovable: true,
             suppressSizeToFit: element.LISTMAXLEN === 20 ? false : true,
             suppressFilter: true,
             menuTabs: [],
             sortingOrder: [],
             cellRendererFramework: fcOption.fcFieldsRender[element.FIELDCODE].renderContent,
             cellRendererParams: (param) => {
               if (fcOption.fcFieldsRender[element.FIELDCODE].cellRendererParams) {
                 return fcOption.fcFieldsRender[element.FIELDCODE].cellRendererParams(param); }
               },
             width
         };
        fields.push(field);
     } else if ( (fcOption.fcShowFields && fcOption.fcShowFields.indexOf(element.FIELDCODE) !== -1) || checkFieldIsProcessEd ) {
       const width = element.LISTMAXLEN
         ? element.LISTMAXLEN * 13 + 10
         : 5 * 13 + 10;
       if ((element.ENABLE === undefined || element.ENABLE === 'Y') && (element.SHOWLIST === undefined || element.SHOWLIST === 'Y')) {
         const field: Fclistdatafield = {
           headerName: element.FIELDNAME,
           field: element.FIELDCODE,
           enableRowGroup: false,
           enablePivot: true,
           suppressSizeToFit: element.LISTMAXLEN === 20 ? false : true,
           width,
           allowedAggFuncs: [],
           cellClass: 'text-left',
           headerTooltip: element.FIELDNAME,
           tooltipField: element.FIELDCODE,
           editable: fcOption.fcEnableEdit && element.ENABLEWRITE === 'Y',
           cellEditor: 'agTextCellEditor',
           lockPinned: false,
           pinned: ''
         };
         if (
           element.ENABLELOCK !== undefined &&
           element.ENABLELOCK !== null &&
           element.ENABLELOCK !== '' &&
           element.ENABLELOCK === 'Y'
         ) {
           locktimes++;
           if (locktimes === 1) {
             field.lockPinned = true;
             field.pinned = 'left';
             fields.forEach(f => {
               f.lockPinned = true;
               f.pinned = 'left';
             });
           }
         }
         if (locktimes > 1) {
           field.lockPinned = true;
           field.pinned = 'right';
         }
         if (element.DICCODE) {
           if (element.ENABLEWRITE === 'N' && !fcOption.fcEnableEdit) {
             field.field = element.FIELDCODE + '_DICDESC';
           } else {
             const dics = fcApp.SYSDIC.filter(
               item => item.DICID === element.DICCODE
             );
             if (dics.length !== 0) {
               const dic = dics[0];
               const values = [];
               if (dic.DICTYPE === 'LISTVALUE') {
                 dic.SYSDICDETAIL.forEach(item => {
                   values.push(item.DICDESC);
                 });
                 field.cellEditorParams = {
                   values
                 };
                 field.cellEditor = 'agSelectCellEditor';
                 field.field = element.FIELDCODE + '_DICDESC';
               }
             }
           }
         }
         if (element.DBTYPE === 'STR') {
           field.enableRowGroup = true;
           field.enablePivot = true;
         }
         if (element.DICCODE !== null || element.DBTYPE === 'DATE') {
           field.cellClass = 'text-center';
         }
         if ('url' === element.INPUTTYPE) {
           field.cellClass = 'text-link';
         }
         if ('NUM' === element.DBTYPE) {
           field.cellClass = 'text-right';
           field.allowedAggFuncs = ['sum', 'min', 'max'];
         }
         field.cellRenderer = params => {
           params.parentContext = this1;
           return cellRenderer(this1, params, element);
         };
         fields.push(field);
       }
     }
   });
   // æä½æé®å¨å³è¾¹
   if (fcOption.fcEnableAction && fcOption.fcActionPosition === 'right') {
     fields.push(getAction(fcApp, fcBustype));
   }
   return fields;
 } else {
   return [];
 }
}

export function findWithQuery(condition: any, requestParam: any, pageNum: number, fcUrl: string, app: Fcapp, fcOption: GRIDOPTIONS) {
  const con: any = {...condition, ...requestParam, ...{PAGENUM: pageNum}};
  if (fcOption) {
    if (fcOption.fcPagination && fcOption.fcPaginationPageSize) {
      con.PAGESIZE = fcOption.fcPaginationPageSize;
    } else if (app) {
      con.PAGESIZE = app.PSIZE;
    }
  }
  if (app) {
    con.AID = app.APPID;
  }
  return ParentBusiness.daoService.getFromApi(fcUrl, con);
}

export function processData(parantPage: any, fieldDic: any[], data: any[], totalSize: number) {
 data.forEach((item, index) => {
   item.ROWNUM = index + 1;
   /** åé¡µåºå·è¿ç»­ */
   if (this.fcOption.fcPagination === true) {
     item.ROWNUM =
       Number(this.pageNum) * this.pageSize -
       this.pageSize +
       index +
       1;
   }
   item.DOACTION = {
     providers: parantPage.provider,
     appId: this.fcAppid,
     parentComponent: parantPage
   };
   if (fieldDic) {
     fieldDic.forEach(dic => {
       const dicdesc = ParentBusiness.appService.getDicdescByFieldCode(
         dic,
         item[dic.FIELDCODE]
       );
       if (dicdesc) {
         Object.assign(item, dicdesc);
       }
     });
   }
 });
 this.data = data;
 if (this._gridApi && this._selectIds.length > 0) {
   selectRowById(
     this._gridApi,
     this._selectIds,
     this.fcSelectedFieldName
   );
 }
 this.pageTotal = totalSize;
}

export class FclistdataBusiness extends ParentBusiness {
  static fcOption: GRIDOPTIONS = {
    /** ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼ */
    fcClass: 'ag-theme-blue',
    fcHeight: 450,
    fcPaginationPageSize: 20,
    fcRowHeight: 28,
    /** æ¯å¦å¯ç¨æ¥è¯¢ */
    fcEnableSearch: false,
    /** æ¯å¦å¯ç¨æåº */
    fcEnableSorting: true,
    /** æ¯å¦å¯ç¨è¿æ»¤ */
    fcEnableFilter: true,
    /** æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å° */
    fcEnableColResize: true,
    /** æ¯å¦æ¾ç¤ºå·¥å·æ  */
    fcShowToolPanel: true,
    /** æ¯å¦åé¡µ */
    fcPagination: true,
    /** æ¯å¦æ¾ç¤ºåç»  alwaysæ»æ¯æ¾ç¤ºï¼noneä¸æ¾ç¤º */
    fcRowGroupPanelShow: 'none',
    /** æ¯å¦å¯ç¨ç¶ææ  */
    fcEnableStatusBar: true,
    /** æ¯å¦å¯ç¨åºåéä¸­ */
    fcEnableRangeSelection: true,
    /** éä¸­æ¹å¼ */
    fcRowSelection: 'multiple',
    /** æ¯å¦å¯ç¨æä½å */
    fcEnableAction: true,
    // æä½æé®ä½ç½®
    fcActionPosition: 'right',
    /** éä¸­æcheckbox */
    fcCheckboxSelection: true,
    /** æ¯å¦å¯ç¨ç¼è¾ */
    fcEnableEdit: true,
    /** æ¯å¦å¯ç¨è¡å· */
    fcEnableRownum: true,
    /** æ¯å¦èªå¨ä¿å­ */
    fcAutoSave: true,
    /** èªå¨è°æ´å¤§å° */
    fcAutoSize: true,
    /** æ¯å¦å¯ç¨ä¸æ */
    fcSelect: false,
    /** æ¯å¦å¯ç¨æ°æ®å­å¸çcheckbox */
    fcEnableDic: false,
    /** é»è®¤çæ¸²æ */
    fcFieldsRender: {}
  };

  /**
   * è½¬æ¢æag-gridè¯å«çéç½®
   * @param appId åæ°æ®å¯¹è±¡
   */
  public static getFieldsConfByAppid(
    appId: string,
    fcOption
  ): Fclistdatafield[] {
    if (fcOption === undefined || fcOption === null) {
      fcOption = this.fcOption;
    }
    return this.getFieldsConfByApp(
      ParentBusiness.appService.getAppById(appId),
      fcOption
    );
  }
  /**
   * æ ¹æ®æ¨¡ååéç½®è·ååä¿¡æ¯
   * @param fcApp æ¨¡ååç§°
   * @param fcOption éé¡¹
   */
  public static getFieldsConfByApp(
    fcApp: Fcapp,
    fcOption = this.fcOption
  ): Fclistdatafield[] {
    if (fcApp) {
      const fieldsList = fcApp.SYSAPPFIELDS;
      const this1 = this;
      const fields: Fclistdatafield[] = [];
      // éæ©å¤éæ¡
      if (
        fcOption.fcCheckboxSelection !== undefined &&
        fcOption.fcCheckboxSelection
      ) {
        if (
          fcOption.fcTreeData === undefined ||
          fcOption.fcTreeData === false
        ) {
          fields.push(this.getCheckbox(fcOption));
        }
      }
      if (fcOption.fcTreeData === undefined || fcOption.fcTreeData === false) {
        if (
          fcOption.fcEnableRownum === undefined ||
          fcOption.fcEnableRownum === true
        ) {
          // åºå·
          fields.push(this.getRownum());
        }
      }
      // æä½æé®å¨å·¦è¾¹
      if (fcOption.fcEnableAction && fcOption.fcActionPosition === 'left') {
        fields.push(this.getAction(fcApp));
      }
      let locktimes = 0;
      fieldsList.forEach(element => {
        // èªå®ä¹ç»ä»¶æ¾ç¤º
        if (((fcOption.fcShowFields && fcOption.fcShowFields.indexOf(element.FIELDCODE) !== -1) ||
        fcOption.fcShowFields === undefined)  && fcOption.fcFieldsRender &&  fcOption.fcFieldsRender[element.FIELDCODE]) {
          const width = element.LISTMAXLEN ? element.LISTMAXLEN * 13 + 10 : 5 * 13 + 10;
          fields.push({
            headerName: element.FIELDNAME,
            field: element.FIELDCODE,
            enableRowGroup: false,
            enablePivot: false,
            allowedAggFuncs: [],
            suppressMovable: true,
            suppressSizeToFit: element.LISTMAXLEN === 20 ? false : true,
            suppressFilter: true,
            menuTabs: [],
            sortingOrder: [],
            cellRendererFramework: fcOption.fcFieldsRender[element.FIELDCODE].renderContent,
            width
          });
        } else if ( (fcOption.fcShowFields && fcOption.fcShowFields.indexOf(element.FIELDCODE) !== -1) ||
          fcOption.fcShowFields === undefined ) {
          const width = element.LISTMAXLEN
            ? element.LISTMAXLEN * 13 + 10
            : 5 * 13 + 10;
          if (element.ENABLE === 'Y' && element.SHOWLIST === 'Y') {
            const field: Fclistdatafield = {
              headerName: element.FIELDNAME,
              field: element.FIELDCODE,
              enableRowGroup: false,
              enablePivot: true,
              suppressSizeToFit: element.LISTMAXLEN === 20 ? false : true,
              width,
              allowedAggFuncs: [],
              cellClass: 'text-left',
              headerTooltip: element.FIELDNAME,
              tooltipField: element.FIELDCODE,
              editable: fcOption.fcEnableEdit && element.ENABLEWRITE === 'Y',
              cellEditor: 'agTextCellEditor',
              lockPinned: false,
              pinned: ''
            };
            if (
              element.ENABLELOCK !== undefined &&
              element.ENABLELOCK !== null &&
              element.ENABLELOCK !== '' &&
              element.ENABLELOCK === 'Y'
            ) {
              locktimes++;
              if (locktimes === 1) {
                field.lockPinned = true;
                field.pinned = 'left';
                fields.forEach(f => {
                  f.lockPinned = true;
                  f.pinned = 'left';
                });
              }
            }
            if (locktimes > 1) {
              field.lockPinned = true;
              field.pinned = 'right';
            }
            if (element.DICCODE !== null) {
              if (element.ENABLEWRITE === 'N' && !fcOption.fcEnableEdit) {
                field.field = element.FIELDCODE + '_DICDESC';
              } else {
                const dics = fcApp.SYSDIC.filter(
                  item => item.DICID === element.DICCODE
                );
                if (dics.length !== 0) {
                  const dic = dics[0];
                  const values = [];
                  if (dic.DICTYPE === 'LISTVALUE') {
                    dic.SYSDICDETAIL.forEach(item => {
                      values.push(item.DICDESC);
                    });
                    field.cellEditorParams = {
                      values
                    };
                    field.cellEditor = 'agSelectCellEditor';
                    field.field = element.FIELDCODE + '_DICDESC';
                  }
                }
              }
            }
            if (element.DBTYPE === 'STR') {
              field.enableRowGroup = true;
              field.enablePivot = true;
            }
            if (element.DICCODE !== null || element.DBTYPE === 'DATE') {
              field.cellClass = 'text-center';
            }
            if ('url' === element.INPUTTYPE) {
              field.cellClass = 'text-link';
            }
            if ('NUM' === element.DBTYPE) {
              field.cellClass = 'text-right';
              field.allowedAggFuncs = ['sum', 'min', 'max'];
            }
            field.cellRenderer = params => {
              params.parentContext = this1;
              return cellRenderer(this1, params, element);
            };
            fields.push(field);
          }
        }
      });
      // æä½æé®å¨å³è¾¹
      if (fcOption.fcEnableAction && fcOption.fcActionPosition === 'right') {
        fields.push(this.getAction(fcApp));
      }
      return fields;
    } else {
      return [];
    }
  }
  /**
   * è¿åå¸¦checkbox
   * @param fcOption xuanx
   */
  public static getCheckbox(fcOption): any {
    return {
      field: '',
      suppressSizeToFit: true,
      suppressResize: true,
      suppressMovable: false,
      suppressFilter: true,
      headerCheckboxSelection: fcOption.fcCheckboxSelection,
      checkboxSelection: fcOption.fcCheckboxSelection,
      suppressSorting: true,
      menuTabs: [],
      sortingOrder: [],
      width: 35
    };
  }
  /**
   * è¿åæä½å
   */
  public static getRownum(): any {
    return {
      headerName: 'åºå·',
      field: 'ROWNUM',
      suppressSizeToFit: true,
      suppressResize: true,
      cellClass: 'text-center',
      suppressMovable: false,
      suppressFilter: true,
      suppressSorting: true,
      menuTabs: [],
      sortingOrder: [],
      width: 50
    };
  }
  /**
   * æ ¹æ®é¿åº¦è·åæé®
   * @param width é¿åº¦
   */
  public static getAction(fcApp: Fcapp): any {
    let width = 110;
    if (fcApp) {
      width = 0;
      fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'LISTONE').forEach(
        btn => {
          width += btn.BTNNAME.length * 17 + 10;
        }
      );
    }
    return {
      headerName: 'æä½',
      field: 'DOACTION',
      enableRowGroup: false,
      enablePivot: false,
      allowedAggFuncs: [],
      suppressMovable: true,
      suppressSizeToFit: true,
      suppressFilter: true,
      menuTabs: [],
      sortingOrder: [],
      cellRendererFramework: FctlblistitemComponent,
      width
    };
  }
  /**
   * éä¸­ï¼fcSelectedFieldNameä½ä¸ºkeyï¼æ»¡è¶³valuesä¸­çå¼ä¸ºåçåéä¸­
   * @param ids idéå
   */
  static selectRowById(gridApi, values: string[], fcSelectedFieldName: string) {
    gridApi.forEachNode(node => {
      if (
        values.filter(value => node.data[fcSelectedFieldName] === value)
          .length > 0
      ) {
        node.selected = true;
      } else {
        node.selected = false;
      }
      gridApi.updateRowData({ update: [node.data] });
    });
  }
}
/** æ¸²ælistwindowçè¡¨æ ¼åå®¹åè¡¨æ ¼æ ¼å¼å */
export function cellRenderer(this1, params: any, field) {
  if (params.data) {
    if (
      params.data[params.colDef.field] &&
      params.data[params.colDef.field] !== 'null'
    ) {
      /** åç¼ */
      const prefix = field.VIEWPREFIX ? field.VIEWPREFIX : '';
      /** åç¼ */
      const suffix = field.VIEWSUFFIX ? field.VIEWSUFFIX : '';
      /** ä¸æ */
      /** æ°æ®å­å¸,checkæ¯å¦ãå¯ç¨åç¨ */
      const check = true;
      if (
        undefined !== field.VIEWFORMAT &&
        '' !== field.VIEWFORMAT &&
        null !== field.VIEWFORMAT
      ) {
        if (field.DBTYPE === 'NUM') {
          return (
            '<span title="' +
            prefix +
            params.data[params.colDef.field] +
            '">' +
            prefix +
            CommonService.numberFormat(
              params.data[params.colDef.field],
              field.VIEWFORMAT
            ) +
            suffix +
            '</span>'
          );
        } else if (field.DBTYPE === 'DATE') {
          return (
            '<span title="' +
            prefix +
            params.data[params.colDef.field] +
            '">' +
            prefix +
            CommonService.dateFormat(
              CommonService.stringToDate(
                String(params.data[params.colDef.field])
              ),
              field.VIEWFORMAT
            ) +
            suffix +
            '</span>'
          );
        }
      } else if (field.INPUTTYPE === 'checkbox') {
        const checkboxFieldCode = params.colDef.field.replace('_DICDESC', '');
        if (params.data[checkboxFieldCode] === 'Y') {
          /** å¤éæ¡ */
          return (
            '<input type="checkbox" id="' +
            params.data.ID +
            '.' +
            field.FIELDCODE +
            '"value=' +
            params.data[params.colDef.field] +
            ' ' +
            'checked="checked"/>'
          );
        } else if (params.data[checkboxFieldCode] === 'N') {
          return (
            '<input type="checkbox" id="' +
            params.data.ID +
            '.' +
            field.FIELDCODE +
            '"value=' +
            params.data[params.colDef.field] +
            '/>'
          );
        }
      } else {
        return (
          '<span title="' +
          prefix +
          params.data[params.colDef.field] +
          '">' +
          prefix +
          params.data[params.colDef.field] +
          suffix +
          '</span>'
        );
      }
    } else {
      return '<span title=""></span>';
    }
  }
}
export interface Fclistdatafield {
  field?: string;
  suppressSizeToFit?: boolean;
  suppressResize?: boolean;
  suppressMovable?: boolean;
  suppressFilter?: boolean;
  headerCheckboxSelection?: boolean;
  checkboxSelection?: boolean;
  suppressSorting?: boolean;
  menuTabs?: any[];
  sortingOrder?: any[];
  width?: number;
  headerName?: string;
  cellClass?: string;
  enableRowGroup?: boolean;
  enablePivot?: boolean;
  allowedAggFuncs?: any[];
  cellRenderer?: (params: any) => {};
  cellRendererFramework?: any;
  headerTooltip?: string;
  tooltipField?: string;
  editable?: boolean;
  cellEditor?: string;
  lockPinned?: boolean;
  pinned?: string;
  cellEditorParams?: any;
  cellRendererParams?: (params: any) => {};
}
/**
 * æ¸²ææ¹å¼
 */
export interface FieldRender {
  // æ¸²ææ¹å¼ 0:ç»ä»¶  1:html
  rendertype?: string;
  // æ¸²æåå®¹;
  renderContent?: any;
}
export interface GRIDOPTIONS {
  /** ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼ */
  fcClass?: string;
  /** åè¡¨é«åº¦ */
  fcHeight: number;
  /** è¡é«é«åº¦ */
  fcRowHeight: number;
  /** æ¯å¦å¯ç¨æåº */
  fcEnableSorting: boolean;
  /** æ¯å¦å¯ç¨æ¥è¯¢ */
  fcEnableSearch: boolean;
  /** æ¯å¦å¯ç¨è¿æ»¤ */
  fcEnableFilter: boolean;
  /** æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å° */
  fcEnableColResize: boolean;
  /** æ¯å¦æ¾ç¤ºå·¥å·æ  */
  fcShowToolPanel?: boolean;
  /** æ¯å¦åé¡µ */
  fcPagination: boolean;
  /** æ¯å¦æ¾ç¤ºåç» */
  fcRowGroupPanelShow?: string;
  /** æ¯å¦å¯ç¨ç¶ææ  */
  fcEnableStatusBar: boolean;
  /** é¡µåç§»é */
  fcPaginationPageSize: number;
  /** æ¯å¦å¯ç¨åºåéä¸­ */
  fcEnableRangeSelection: boolean;
  /** éä¸­æ¹å¼ */
  fcRowSelection: string;
  /** åå®ä¹ */
  fcFields?: any[];
  /** æ¯å¦å¯ç¨æä½å */
  fcEnableAction?: boolean;
  /** æä½åä½ç½® */
  fcActionPosition?: string;
  /** åè¡¨é»è®¤æåº */
  fcOrder?: string;
  /** éä¸­æcheckbox */
  fcCheckboxSelection: boolean;
  /** æ¯å¦å¯ç¨ç¼è¾ */
  fcEnableEdit: boolean;
  /** æ¯å¦å¯ç¨è¡å· */
  fcEnableRownum?: boolean;
  /** æ¯å¦èªå¨ä¿å­ */
  fcAutoSave?: boolean;
  /** æ¯å¦èªå¨è°æ´å¤§å° */
  fcAutoSize?: boolean;
  /** æ¯å¦å¯ç¨ä¸æ */
  fcSelect?: boolean;
  /** æ¯å¦å¯ç¨æ°æ®å­å¸çcheckbox */
  fcEnableDic?: boolean;
  // æ¾ç¤ºçå­æ®µåç§°
  fcShowFields?: string;
  // æ¯å¦æ¯æ æ¨¡å
  fcTreeData?: boolean;
  // è·åæ°å¼æ¹å¼
  fcGetDataPath?: () => {};
  fcGroupDefaultExpanded?: number;
  fcAutoGroupColumnDef?: string;
  // ç®åæ¨¡å¼
  fcSample?: string;
  // æ¯å¦åç¨èªå®ä¹æ¸²ææ¹å¼
  fcFieldsRender?: any;
  // æé®ç»
  fcButtons?: Sysappbuttons[];
  // å­å¸éç½®
  fcDics?: Sysdic[];
  // è¿æ¥å°å
  fcLinks?: Sysapplinks[];
  // å­æ®µåç»
  fcFieldsGroup?: Sysappbuttons[];
}
export const GRIDOPSLOCALE = {
  icons: {
    /** èåå¾æ çä½¿ç¨å­ä½ */
    menu: '<i class="icon iconfont icon-pitchon"/>',
    filter: '<i class="icon iconfont icon-unfold"/>',
    columns: '<i class="icon iconfont icon-packup"/>'
  },
  localeText: {
    /** for filter panel */
    page: 'é¡µ',
    more: 'æ´å¤',
    to: 'å°',
    of: 'å±',
    next: 'ä¸ä¸é¡µ',
    last: 'å°¾é¡µ',
    first: 'ç¬¬ä¸é¡µ',
    previous: 'ä¸ä¸é¡µ',
    loadingOoo: 'å è½½ä¸­',
    /** for set filter */
    selectAll: 'å¨é',
    searchOoo: 'æç´¢',
    blanks: 'daBlanc',
    /** for number filter and text filter */
    filterOoo: 'è¿æ»¤',
    applyFilter: 'daApplyFilter...',
    /** for number filter */
    equals: 'ç­äº',
    notEqual: 'ä¸ç­äº',
    lessThanOrEqual: 'å°äºç­äº',
    greaterThanOrEqual: 'å¤§äºç­äº',
    inRange: 'èå´',
    lessThan: 'å°äº',
    greaterThan: 'å¤§äº',
    /** for text filter */
    contains: 'åå«',
    startsWith: 'å¼å§',
    endsWith: 'ç»æ',
    /** the header of the default group column */
    group: 'åç»',
    /** tool panel */
    columns: 'å',
    rowGroupColumns: 'è¡ç»å',
    rowGroupColumnsEmptyMessage: 'ååç»',
    valueColumns: 'åå¹¶ååæ ¼å¼',
    pivotMode: 'æ¾ç¤ºå',
    groups: 'åç»',
    values: 'å¼',
    pivots: 'æ¯ç¹',
    valueColumnsEmptyMessage: 'æå¨åè¿è¡èå',
    pivotColumnsEmptyMessage: 'æå°è¿é',
    /** other */
    noRowsToShow: 'ææ æ°æ®',
    /** enterprise menu */
    valueAggregation: 'ä»·å¼èå',
    autosizeThiscolumn: 'è°æ´æ¬å',
    autosizeAllColumns: 'è°æ´ææ',
    groupBy: 'åç»',
    ungroupBy: 'åæ¶åç»',
    resetColumns: 'éç½®åå®½',
    expandAll: 'å±å¼å¨é¨',
    collapseAll: 'å¨é¨æ¶èµ·',
    toolPanel: 'å·¥å·é¢æ¿',
    export: 'å¯¼åº',
    csvExport: 'å¯¼åºä¸ºcsv',
    excelExport: 'å¯¼åºä¸ºexcel',
    /** enterprise menu pinning */
    pinColumn: 'ç§»å°',
    pinLeft: 'æå·¦è¾¹',
    pinRight: 'æå³è¾¹',
    noPin: 'åºå®',
    /** enterprise menu aggregation and status panel */
    sum: 'åè®¡',
    min: 'æå°å¼',
    max: 'æå¤§å¼',
    none: 'æ ',
    count: 'è®¡æ°',
    average: 'åå¼',
    /** standard menu */
    copy: 'å¤å¶',
    ctrlC: 'æä½ctrl+C',
    paste: 'ç²è´´',
    ctrlV: 'æä½ctrl+V '
  }
};

export interface FclistsearchConfig {
  /** è¡¨åæ é¢ */
  fcTitle?: string;
  /** è¡¨åå¯æ é¢ */
  fcSubTitle?: string;
  /** fcFields?: Sysappfields[]; */
  fcFields?: any[];
  /** è¡¨åéç½® */
  /** fcToolbar?: Sysappbuttons[]; */
  fcToolbar?: any[];
  fcFieldDics?: any;
  fcAct?: SEARCHACTION;
  fcLayout?: string;
  fcValidate?: FormGroup;
  /** ååæ° */
  fcSpans?: number;
}
export interface FclistsearchmodalOption {
  fcAppid: string;
  fcTitle: string;
  fcType: string;
  fcCondition: string;
}
export enum SEARCHACTION {
  /** æ°å¢ */
  ADD,
  /** ä¿®æ¹ */
  MODIFY
}
export const SEARCHLAYOUT = {
  INLINE: 'inline',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
